import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {BedModel} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function editBedService(dto: BedModel) {
  return await axios.put<ResponseObject<BedModel>>(`${BASEURL}/bed/updateBed`, dto)
}
